import React, {useState} from 'react';
import {Form, Input, Button, Card, message, Select, Switch} from 'antd';
import {useNavigate, useParams} from 'react-router-dom';
import axios from 'axios';
import MathText from "../../components/MathText";
import {API_BASE_URL} from "../../config";
import FileUploader from "../../components/FileUploader";
import '../Styles.css'

const AddSatQuestion = () => {
    const [form] = Form.useForm();
    const [qContent, setQContent] = useState('');
    const [leftsideText, setLeftsideText] = useState('');
    const [qVariant1, setQVariant1] = useState('');
    const [qVariant2, setQVariant2] = useState('');
    const [qVariant3, setQVariant3] = useState('');
    const [qVariant4, setQVariant4] = useState('');
    const [writable, setWritable] = useState(false);
    const [split, setSplit] = useState(false);
    const navigate = useNavigate();
    const {collection_id} = useParams();
    const {step} = useParams();

    const refactorContent = (content) => {
        if (content.includes("\n\n")) {
            const parts = content
                .split(/\n{2,}/)
                .map(part => part.trim())
                .filter(Boolean);

            const fieldsToUpdate = {};

            if (parts.length > 0) {
                setQContent(parts[0]);
            }
            const stripLabel = (text, label) => text.startsWith(label + ' ') ? text.slice(label.length + 1) : text.startsWith(label) ? text.slice(label.length) : text;
            if (parts.length > 1) {
                setQVariant1(stripLabel(parts[1], 'A)'));
            }
            if (parts.length > 2) {
                setQVariant2(stripLabel(parts[2], 'B)'));
            }
            if (parts.length > 3) {
                setQVariant3(stripLabel(parts[3], 'C)'));
            }
            if (parts.length > 4) {
                setQVariant4(stripLabel(parts[4], 'D)'));
            }
            form.setFieldsValue(fieldsToUpdate);
        } else {
            setQContent(content);
        }
    };


    const onValuesChange = (changedValues) => {
        if ('content' in changedValues) {
            refactorContent(changedValues.content)
            // setQContent(changedValues.content);
        }
        if ('leftsideText' in changedValues) {
            setLeftsideText(changedValues.leftsideText)
        }
    };


    const handleImageInsertLeftsideText = (file_name) => {
        const currentText = form.getFieldValue('leftsideText') || '';
        const updatedText = currentText + `$\\includegraphics[width=0.4\\textwidth]{${file_name}}$`;
        form.setFieldsValue({leftsideText: updatedText});
        setLeftsideText(updatedText);
    };

    const handleImageInsert = (file_name) => {
        const currentContent = form.getFieldValue('content') || '';
        const updatedContent = currentContent + `$\\includegraphics[width=0.4\\textwidth]{${file_name}}$`;
        form.setFieldsValue({content: updatedContent});
        setQContent(updatedContent);
    };

    const onFinish = async (values) => {
        try {
            values['content'] = qContent
            values['variant1'] = qVariant1
            values['variant2'] = qVariant2
            values['variant3'] = qVariant3
            values['variant4'] = qVariant4
            await axios.post(`${API_BASE_URL}/api/SatQuestion`, {
                ...values,
                satCollectionId: parseInt(collection_id, 10),
                step: step,
            });
            message.success('Question added');
            navigate(`/sat-collection/${collection_id}/questions?tab=${step}`);
        } catch (error) {
            message.error('Failed to add question');
        }
    };

    return (
        <Card title="Add Question" style={{margin: 'auto'}}>
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                onValuesChange={onValuesChange}
            >
                <div className="flex-form-row">
                    <Form.Item name="split" label="Split" valuePropName="checked">
                        <Switch checked={split} onChange={setSplit}/>
                    </Form.Item>
                    <Form.Item name="writable" label="Writable" valuePropName="checked" style={{paddingLeft: "50px"}}>
                        <Switch checked={writable} onChange={setWritable}/>
                    </Form.Item>
                </div>
                <div className="flex-form-row" style={{display: "flex"}}>
                    {split ? <Form.Item
                        name="leftsideText"
                        style={{flex: 1}}
                        label={
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: 10
                            }}>
                                <label style={{fontWeight: 500, paddingRight: 20}}>
                                    Leftside Text
                                </label>
                                <FileUploader setImage={handleImageInsertLeftsideText}/>
                            </div>
                        }
                        rules={[{required: false}]}
                    >
                        <Input.TextArea rows={12} placeholder="Enter leftside text"/>
                    </Form.Item> : ""}
                    <Form.Item
                        name="content"
                        style={{flex: 1}}
                        label={
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: 10
                            }}>
                                <label style={{fontWeight: 500, paddingRight: 20}}>
                                    Content
                                </label>
                                <FileUploader setImage={handleImageInsert}/>
                            </div>
                        }
                        rules={[{required: true}]}
                    >
                        <Input.TextArea rows={12} placeholder="Enter question content"/>
                    </Form.Item>
                </div>
                <div className="flex-form-row">
                    {split ?
                        <div style={{flex: 1, marginRight: 8}}><MathText text={leftsideText}/>
                        </div> : ""
                    }
                    <div style={{flex: 1}}>
                        <MathText text={qContent}/>
                        <br/>
                        {writable ? (
                            <Form.Item
                                name='answer'
                                label='Answer'
                                rules={[{required: true}]}
                            >
                                <Input placeholder="Paste here answer or answers. For example: ans1;ans2;"/>
                            </Form.Item>
                        ) : (
                            <>
                                <MathText text={`A) ${qVariant1}`}/><br/>
                                <MathText text={`B) ${qVariant2}`}/><br/>
                                <MathText text={`C) ${qVariant3}`}/><br/>
                                <MathText text={`D) ${qVariant4}`}/><br/>
                                <Form.Item
                                    name="answer"
                                    label="Answer"
                                    rules={[{required: true}]}
                                >
                                    <Select placeholder="Select correct answer">
                                        <Select.Option value="A">A</Select.Option>
                                        <Select.Option value="B">B</Select.Option>
                                        <Select.Option value="C">C</Select.Option>
                                        <Select.Option value="D">D</Select.Option>
                                    </Select>
                                </Form.Item>
                            </>
                        )}
                    </div>
                </div>

                <Form.Item
                    key='link'
                    name='link'
                    label='Video link'
                    rules={[{required: false}]}
                >
                    <Input placeholder={`Paste here video url from telegram`}/>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">Add Question</Button>
                </Form.Item>
                <Form.Item>
                    <Button onClick={() => navigate(`/sat-collection/${collection_id}/questions?tab=${step}`)}>
                        Cancel
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
        ;
};

export default AddSatQuestion;
